import { RootState } from "@redux/store"
import { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"
import useSubscriptionData from "./use-subscription-data"

const useUserCheckTrial = () => {
    const [ isTrial, setIsTrial ] = useState<boolean | null>(null)
    const [ hasLoaded, setHasLoaded ] = useState<boolean>(false)
    const session = useSelector((state: RootState) => state.session)

    const currentPlanName = useMemo(() => {
        if(session.plan?.name)
            return session.plan?.name
        if(session.isPremium)
            return "PREMIUM"
        return "FREE"
    }, [session])

    const { data: subscriptionPaid, freeTrial, organizationSub, isLoading: isCheckingSubsLoading, hasActiveCoupon } = useSubscriptionData(currentPlanName || "")

    useEffect(() => {
        setHasLoaded(false)
        if((freeTrial === null && hasActiveCoupon === null)) return
        if(isCheckingSubsLoading) return

        setIsTrial(freeTrial || hasActiveCoupon)
        setHasLoaded(true)
        // console.debug(subscriptionPaid, freeTrial, isLoading, organizationSub)
    }, [subscriptionPaid, freeTrial, isCheckingSubsLoading, organizationSub, hasActiveCoupon])

    return { isTrial, hasLoaded }
}

export default useUserCheckTrial
